'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducer = require('../components/Schemas/reducer');

Object.defineProperty(exports, 'schemas', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducer).default;
  }
});

var _reducer2 = require('../components/Forms/reducer');

Object.defineProperty(exports, 'forms', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducer2).default;
  }
});

var _reducer3 = require('../components/Hooks/reducer');

Object.defineProperty(exports, 'hooks', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducer3).default;
  }
});

var _reducer4 = require('../components/Datasources/reducer');

Object.defineProperty(exports, 'datasource', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducer4).default;
  }
});

var _reducer5 = require('../components/FormData/reducer');

Object.defineProperty(exports, 'formdata', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducer5).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/data/reducers.js
// module id = 1125
// module chunks = 5